module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec07_2a25ffffcb1bfa57789729b67e0408cc.jpg";